import { Config } from "../config/config";
import { ComponentHelper } from "../util/componentHelper";
import { Helper } from "../util/helper";
import { HTTPService, JsonResultClass } from "../util/httpManager";
import { NotificationHelper } from "../util/notificationHelper";
import { DropDownList } from "./dropDownList"
import { Button, ButtonProps } from "./button"
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { BaseComponentProps } from "./baseComponentProps";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export default class IconSelection extends React.Component<IconSelectionProps, IconSelectionState>{
    private dataSource: Icon[];
    private translations: StringKeyDictionary<string>;
    private factory = ComponentHelper.createFactory();
    private canCreate: boolean = false;
    private canOpen: boolean = false;
    private initialId: string;
    constructor(props: IconSelectionProps) {
        super(props)
        this.state = {
            value: props.value
        }
        if (Config.user.iconsAreActive)
            this.initApp();
    }

    private initApp = async () => {
        this.initialId = this.props.value
        const results = await Promise.all([
            this.loadDataSource(),
            Helper.getTranslations(["WebSMS.ResourcePlanningScheduler.Icon.IconIsDeleted"])
        ]);
        this.translations = results[1].Data;
        this.setState({})
    }

    private loadDataSource = async () => {
        const result = await HTTPService.noBusyIndicator().get<JsonResultClass>(`Icon/GetAllIcons?includedId=${this.initialId}`);
        if (result.Code == 0) {
            this.dataSource = result.Data;
            this.canCreate = result.AdditionalData["canCreate"];

        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
    }

    private setValue = (value: string) => {
        this.setState({ value: value }, () => {
            this.props.onChange(this.props.field, value, this.dataSource.find(f => f.Id === value));
        })
    }

    private renderDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.dataSource = JSON.parse(JSON.stringify(this.dataSource));
        props.value = this.state.value;
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.disabled = this.props.disabled;
        props.field.refreshDSOnRefChange = true;
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:150px'><colgroup><col style='width: 125px' /><col style='width: 25px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td><td style='vertical-align:top'><span style='margin-left: 5px; color: ${data.Color};'>&\\#x${data.HexCode}</span></td></tr></table>";
        props.field.valueTemplate = "<span>${data.Name}<span style='margin-left: 5px; color: ${data.Color};'>&\\#x${data.HexCode}</span></span>";
        props.onChange = (_, value) => {
            if (Helper.isNullOrEmpty(value))
                value = null;
            this.setValue(value);
        }
        return (
            <div style={{ width: "100%", paddingTop: "1px" }}>
                <DropDownList {...props} />
            </div>
        );
    }

    private renderCreateButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.openSheet();
            },
            iconName: "plus",
            title: Config.translations.newLabel,
            buttonStyle: {
                marginLeft: "5px",
                borderRadius: "var(--border-radius)",
                height: "40px"
            }
        }
        return (
            <>
                <Button {...props} />
            </>
        );
    }

    private openSheet = (id: string = null) => {
        const url = "Icon/Edit" + (!Helper.isNullOrEmpty(id) ? `?id=${id}` : "");
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.SavedSuccessfully, async (data) => {
            await this.loadDataSource();
            this.setState({}, () => {
                this.setValue(data.entity.Id);
            });
        })
    }

    render() {
        if (Config.user.iconsAreActive && Helper.hasValue(this.dataSource)) {
            const selected = this.dataSource.find(f => f.Id == this.state.value);
            return (
                <div>
                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "row-reverse", marginBottom: "2px" }}>
                        {this.canCreate && !this.props.disabled ? this.renderCreateButton() : null}
                        {this.renderDropDown()}
                    </div>
                    {
                        Helper.hasValue(selected) && selected.IsDeleted ? (
                            <label style={{ fontSize: "12px", color: "#d32f2f" }}>
                                {Helper.hasValue(this.translations) ? this.translations["WebSMS.ResourcePlanningScheduler.Icon.IconIsDeleted"] : null}
                            </label>
                        ) : <></>
                    }
                </div>
            );
        } else {
            return null;
        }
    }
}

interface IconSelectionProps extends BaseComponentProps {
    value: string;
}

interface IconSelectionState {
    value: string;
}

interface Icon {
    Id: string;
    Name: string;
    HexCode: string;
    IsDeleted: boolean;
}